import { useTranslation } from 'react-i18next';
import React, { Fragment, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';

import { useProductState } from '../store';
import { XIcon } from '@heroicons/react/solid';
import Image from 'next/future/image';

const SizeGuide = () => {
  const { t } = useTranslation();
  const { product } = useProductState();
  const [isOpen, setIsOpen] = useState(false);

  const sizeGuide = product['size-guide'];

  if (!sizeGuide) {
    return null;
  }

  const sizeMetric = sizeGuide.size_guide_key?.split('_').at(-1);

  function toggleOpen() {
    setIsOpen(isOpen => !isOpen);
  }

  // TODO: @andrea - da adattare style

  return (
    <Fragment>
      <button
        onClick={toggleOpen}
        className="text-xs underline underline-offset-2"
      >
        {t('P_PDP.OVERVIEW.SIZE_GUIDE')}
      </button>

      <Transition show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-20 overflow-y-auto"
          onClose={toggleOpen}
        >
          <div className="flex min-h-full items-center justify-center p-4">
            <Transition.Child
              as={Fragment}
              enter="transition-opacity duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-black/30" />
            </Transition.Child>

            <Transition.Child
              as={Fragment}
              enter="transition-all ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="transition-all ease-in duration-300"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="w-full max-w-2xl bg-white shadow-xl rounded-lg overflow-hidden">
                <Dialog.Title className="flex justify-between items-center bg-gray-200 px-6 py-3">
                  <h3 className="text-2xl font-medium">
                    {t('SIZES_GUIDE')} ({sizeMetric})
                  </h3>

                  <button
                    className="flex justify-center items-center w-8 h-8 bg-white rounded-full"
                    onClick={toggleOpen}
                  >
                    <XIcon className="w-4 h-4 text-primary" />
                  </button>
                </Dialog.Title>

                <div className="flex flex-col items-center space-y-3 sm:p-6 sm:space-y-6">
                  {sizeGuide.size_guide_html && (
                    <div
                      className="w-full overflow-y-auto py-3 sm:py-0"
                      dangerouslySetInnerHTML={{
                        __html: sizeGuide.size_guide_html
                      }}
                    />
                  )}

                  {sizeGuide.size_guide_image && (
                    <Image
                      src="https://trere-uyn.b-cdn.net/technologies/rebound-shield.jpg"
                      alt="Size Guide"
                      width={0}
                      height={0}
                      sizes="100vw"
                      className="w-full h-auto object-contain"
                    />
                  )}
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </Fragment>
  );
};

export default SizeGuide;
